import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

interface ValidateAppleTokenResponseData extends ResponseData {
  body: {
    firstName: string
    lastName: string
    emailAddress: string
    softLogin?: boolean | null
  }
  errorCode:
    | "api_email_already_exist"
    | "api_user_not_found"
    | "api_user_has_been_blocked"
    | "token_invalid"
    | 111008
}

export interface ValidateAppleTokenResponse extends AxiosResponse {
  data: ValidateAppleTokenResponseData
}

export function validateAppleTokenAPI(axiosInstance: AxiosInstance) {
  return axiosInstance({
    data: null,
    method: "post",
    url: "/auth/apple/validate-token",
  }) as Promise<ValidateAppleTokenResponse>
}
